import React from 'react';
import { defineMessages, T } from '@sm/intl';
import { Typography } from '@wds/typography';

import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  container: {
    paddingRight: 20,
    width: '21%',
    '& li': {
      listStylePosition: 'outside',
      listStyleType: 'none',
    },
    '& ul': {
      marginTop: 0,
      paddingLeft: 0,
    },
    '& ul li a': {
      color: '#333E48',
      display: 'block',
      padding: 12,
      fontSize: 15,
      borderBottom: `1px solid #D0D2D3`,
    },
    '& ul li a:hover': {
      background: '#f4f5f5',
      textDecoration: 'none',
    },
    '& ul li a:active': {
      background: '#f4f5f5',
    },
  },
});

const COPY = defineMessages({
  TERMS_OF_USE: {
    id: 'User.NavigationMenu.TermsOfUse',
    defaultMessage: 'Terms of Use',
    description: '[Type: Button][Vis.: med] - Terms of use menu option',
  },
  PRIVACY_NOTICE: {
    id: 'User.NavigationMenu.PrivacyNotice',
    defaultMessage: 'Privacy Notice',
    description: '[Type: Button][Vis.: med] - Privacy notice menu option',
  },
  ANTI_SPAM: {
    id: 'User.NavigationMenu.AntiSpam',
    defaultMessage: 'Anti-Spam',
    description: '[Type: Button][Vis.: med] - Anti-Spam menu option',
  },
  SECURITY_STATEMENT: {
    id: 'User.NavigationMenu.SecurityStatement',
    defaultMessage: 'Security Statement',
    description: '[Type: Button][Vis.: med] - Security statement menu option',
  },
});

const NavigationMenu = () => {
  const classes = useStyles();

  return (
    <nav className={classes.container}>
      <ul className={classes.list} data-testid="NavigationMenu__LinksList">
        <li className={classes.listItem}>
          <Typography>
            <a className={classes.link} href="/mp/legal/terms-of-use/?ut_source=email_opt_out" target="_blank">
              <T desc={COPY.TERMS_OF_USE} html />
            </a>
          </Typography>
        </li>
        <li className={classes.listItem}>
          <Typography>
            <a className={classes.link} href="/mp/legal/privacy-policy/?ut_source=email_opt_out" target="_blank">
              <T desc={COPY.PRIVACY_NOTICE} html />
            </a>
          </Typography>
        </li>
        <li className={classes.listItem}>
          <Typography>
            <a
              className={classes.link}
              href="/mp/legal/acceptable-uses-policy/?ut_source=email_opt_out"
              target="_blank"
            >
              <T desc={COPY.ANTI_SPAM} html />
            </a>
          </Typography>
        </li>
        <li className={classes.listItem}>
          <Typography>
            <a className={classes.link} href="/mp/legal/security/?ut_source=email_opt_out" target="_blank">
              <T desc={COPY.SECURITY_STATEMENT} html />
            </a>
          </Typography>
        </li>
      </ul>
    </nav>
  );
};

export default NavigationMenu;
